import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { HomeFiveComponent } from './components/pages/home-five/home-five.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { AffiliateComponent } from './components/pages/affiliate/affiliate.component';
import { TeamComponent } from './components/pages/team/team.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { LogInComponent } from './components/pages/log-in/log-in.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { RecoverPasswordComponent } from './components/pages/recover-password/recover-password.component';
import { TermsConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ContactComponent } from './components/pages/contact/contact.component';

import { NewsGridComponent } from './components/pages/news-grid/news-grid.component';
import { NewsDetailsComponent } from './components/pages/news-details/news-details.component';
import { NewsRightSidebarComponent } from './components/pages/news-right-sidebar/news-right-sidebar.component';
import { NewsLeftSidebarComponent } from './components/pages/news-left-sidebar/news-left-sidebar.component';
import { DomainComponent } from './components/pages/domain/domain.component';
import { SharedHostingComponent } from './components/pages/shared-hosting/shared-hosting.component';
import { ResellerHostingComponent } from './components/pages/reseller-hosting/reseller-hosting.component';
import { DedicatedHostingComponent } from './components/pages/dedicated-hosting/dedicated-hosting.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { WindowsCloudComponent } from './components/pages/windows-cloud/windows-cloud.component';
import { GpuCloudComponent } from './components/pages/gpu-cloud/gpu-cloud.component';
import { ManagedItComponent } from './components/pages/managed-it/managed-it.component';
import { CloudMigrationComponent } from './components/pages/cloud-migration/cloud-migration.component';
import { CybersecurityComponent } from './components/pages/cybersecurity/cybersecurity.component';
import { BackupRecoveryComponent } from './components/pages/backup-recovery/backup-recovery.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { LinuxCloudComponent } from './components/pages/linux-cloud/linux-cloud.component';
import { StorageCloudComponent } from './components/pages/storage-cloud/storage-cloud.component';
import { VirtualPrivateCloudComponent } from './components/pages/virtual-private-cloud/virtual-private-cloud.component';
import { LoadBalancersComponent } from './components/pages/load-balancers/load-balancers.component';
import { LoadBalancersProfessionalComponent } from './components/pages/load-balancers/load-balancers-professional.component';
import { CloudInfrastructureComponent } from './components/pages/cloud-infrastructure/cloud-infrastructure.component';
import { DocumentationComponent } from './components/pages/documentation/documentation.component';
import { GettingStartedComponent } from './components/pages/documentation/getting-started/getting-started.component';
import { MyAccountComponent } from './components/pages/my-account/my-account.component';
import { CaseStudiesComponent } from './components/pages/case-studies/case-studies.component';
import { HealthcareDiagnosticsComponent } from './components/pages/case-study-details/healthcare-diagnostics/healthcare-diagnostics.component';
import { FinanceFraudComponent } from './components/pages/case-study-details/finance-fraud/finance-fraud.component';
import { ProxmoxApiExplorerComponent } from './components/pages/proxmox-api-explorer/proxmox-api-explorer.component';
import { DbaasComponent } from './components/pages/dbaas/dbaas.component';
import { DevopsComponent } from './components/pages/devops/devops.component';
import { DataCentersComponent } from './components/pages/data-centers/data-centers.component';

// Import new CMP components
import { AdminDashboardComponent } from './components/pages/admin-dashboard/admin-dashboard.component';
import { ClientDashboardComponent } from './components/pages/client-dashboard/client-dashboard.component';
import { VmDetailsComponent } from './components/pages/vm-details/vm-details.component';
import { ClientLoginComponent } from './components/pages/client-login/client-login.component';
import { ClientRegistrationComponent } from './components/pages/client-registration/client-registration.component';

// Import Object Storage component
import { ObjectStorageComponent } from './components/pages/object-storage/object-storage.component';

// Import new storage components
import { IisVolumeComponent } from './components/pages/iis-volume/iis-volume.component';
import { IisCdpBackupComponent } from './components/pages/iis-cdp-backup/iis-cdp-backup.component';
import { SavedImagesComponent } from './components/pages/saved-images/saved-images.component';
import { WindowsSqlCloudComponent } from './components/pages/windows-sql-cloud/windows-sql-cloud.component';

// Import new Linux series components
import { LinuxC3SeriesComponent } from './components/pages/linux-c3-series/linux-c3-series.component';
import { LinuxM3SeriesComponent } from './components/pages/linux-m3-series/linux-m3-series.component';
import { LinuxSdc3SeriesComponent } from './components/pages/linux-sdc3-series/linux-sdc3-series.component';
import { LinuxE1SeriesComponent } from './components/pages/linux-e1-series/linux-e1-series.component';

// Import Event component
import { EventComponent } from './components/pages/event/event.component';
// Import Partner component
import { PartnerComponent } from './components/pages/partner/partner.component';

// Import IIS Pricing component
import { IisPricingComponent } from './components/pages/pricing/iis-pricing.component';

// Import Pricing Calculator component
import { PricingCalculatorComponent } from './components/pages/pricing-calculator/pricing-calculator.component';

// Import URL Redirect component
import { UrlRedirectComponent } from './components/pages/url-redirect/url-redirect.component';

// Import new AI-themed home component
import { HomeAIComponent } from './components/pages/home-ai/home-ai.component';

// Import auth guard
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
    {path: '', component: HomeOneComponent, data: { title: 'Home' }},
    {path: 'home-one', component: HomeOneComponent, data: { title: 'Home One' }},
    {path: 'home-two', component: HomeTwoComponent, data: { title: 'Home Two' }},
    {path: 'home-three', component: HomeThreeComponent, data: { title: 'Home Three' }},
    {path: 'home-four', component: HomeFourComponent, data: { title: 'Home Four' }},
    {path: 'home-five', component: HomeFiveComponent, data: { title: 'Home Five' }},
    {path: 'home-ai', component: HomeAIComponent, data: { title: 'Home - AI Cloud Solutions' }},
    {path: 'about', component: AboutComponent, data: { title: 'About Us' }},
    {path: 'services', component: ServicesComponent, data: { title: 'Services' }},
    {path: 'affiliate', component: AffiliateComponent, data: { title: 'Affiliate Program' }},
    {path: 'team', component: TeamComponent, data: { title: 'Our Team' }},
    {path: 'faq', component: FaqComponent, data: { title: 'FAQ' }},
    // {path: 'log-in', component: LogInComponent, data: { title: 'Login' }},
    // {path: 'sign-up', component: SignUpComponent, data: { title: 'Sign Up' }},
    {path: 'recover-password', component: RecoverPasswordComponent, data: { title: 'Recover Password' }},
    {path: 'terms-conditions', component: TermsConditionsComponent, data: { title: 'Terms & Conditions' }},
    {path: 'privacy-policy', component: PrivacyPolicyComponent, data: { title: 'Privacy Policy' }},
    {path: 'pricing', component: IisPricingComponent, data: { title: 'Pricing' }},
    {path: 'pricing-calculator', component: PricingCalculatorComponent, data: { title: 'Pricing Calculator' }},
    {path: 's/:code', component: UrlRedirectComponent, data: { title: 'Redirecting...' }},
    {path: 'shared-hosting', component: SharedHostingComponent, data: { title: 'Shared Hosting' }},
    {path: 'reseller-hosting', component: ResellerHostingComponent, data: { title: 'Reseller Hosting' }},
    {path: 'dedicated-hosting', component: DedicatedHostingComponent, data: { title: 'Dedicated Hosting' }},
    {path: 'coming-soon', component: ComingSoonComponent, data: { title: 'Coming Soon' }},
    {path: 'error', component: ErrorComponent, data: { title: 'Error' }},
    {path: 'contact', component: ContactComponent, data: { title: 'Contact Us' }},
    {path: 'data-centers', component: DataCentersComponent, data: { title: 'Data Centers in India' }},
    // Here add new pages component
    
    // Cloud Services Routes
    {path: 'gpu-cloud', component: GpuCloudComponent, data: { title: 'GPU Cloud Computing' }}, // Cloud GPU page
    {path: 'tir-platform', component: ServicesComponent, data: { title: 'TIR Platform' }}, // Temporarily using services
    {path: 'linux-cloud', component: LinuxCloudComponent, data: { title: 'Linux Cloud' }}, // Linux Cloud page
    {path: 'windows-cloud', component: WindowsCloudComponent, data: { title: 'Windows Cloud' }}, // Windows Cloud page
    {path: 'windows-sql-cloud', component: WindowsSqlCloudComponent, data: { title: 'Windows SQL Cloud' }}, // Windows SQL Cloud page
    {path: 'storage-cloud', component: StorageCloudComponent, data: { title: 'Cloud Storage' }}, // Storage Cloud page
    {path: 'object-storage', component: ObjectStorageComponent, data: { title: 'Object Storage' }}, // Object Storage page
    {path: 'iis-volume', component: IisVolumeComponent, data: { title: 'IIS Volume Storage' }}, // IIS Volume Storage page
    {path: 'iis-cdp-backup', component: IisCdpBackupComponent, data: { title: 'IIS CDP Backup' }}, // IIS CDP Backup page
    {path: 'saved-images', component: SavedImagesComponent, data: { title: 'Saved Images' }}, // Saved Images page
    {path: 'dbaas', component: DbaasComponent, data: { title: 'Database as a Service' }}, // Database as a Service page
    // Linux Series pages
    {path: 'linux-c3-series', component: LinuxC3SeriesComponent, data: { title: 'CPU Intensive Computing C3 Series' }},
    {path: 'linux-m3-series', component: LinuxM3SeriesComponent, data: { title: 'Memory Intensive Computing M3 Series' }},
    {path: 'linux-sdc3-series', component: LinuxSdc3SeriesComponent, data: { title: 'Linux Smart Dedicated Compute SDC3 Series' }},
    {path: 'linux-e1-series', component: LinuxE1SeriesComponent, data: { title: 'E1 Series: Cloud Nodes Built for Flexibility, Cost-Efficiency & Performance' }},
    
    // Managed IT Services Routes
    {path: 'managed-it', component: ManagedItComponent, data: { title: 'Managed IT Services' }},
    {path: 'cloud-migration', component: CloudMigrationComponent, data: { title: 'Cloud Migration' }},
    {path: 'cybersecurity', component: CybersecurityComponent, data: { title: 'Cybersecurity' }},
    {path: 'backup-recovery', component: BackupRecoveryComponent, data: { title: 'Backup & Recovery' }},
    {path: 'cloud-infrastructure', component: CloudInfrastructureComponent, data: { title: 'Cloud Infrastructure' }}, // Updated to use CloudInfrastructureComponent
    {path: 'devops', component: DevopsComponent, data: { title: 'DevOps Services' }}, // DevOps Services page
    {path: 'cloud-solutions', component: ServicesComponent, data: { title: 'Cloud Solutions' }}, // Temporarily using services
    
    // Solutions Routes
    {path: 'ai-labs-as-a-service', component: ServicesComponent, data: { title: 'AI Labs as a Service' }},
    {path: 'virtual-private-cloud', component: VirtualPrivateCloudComponent, data: { title: 'Virtual Private Cloud' }}, // Virtual Private Cloud page
    {path: 'load-balancers', component: LoadBalancersProfessionalComponent, data: { title: 'Load Balancers' }}, // Load Balancers page
    {path: 'auto-scale', component: ServicesComponent, data: { title: 'Auto Scaling' }},
    {path: 'cdn', component: ServicesComponent, data: { title: 'Content Delivery Network' }},
    
    // Company Routes
    {path: 'event', component: EventComponent, data: { title: 'Events' }},
    
    // Client Routes - Temporarily Hidden
    // {path: 'client-login', component: ClientLoginComponent, data: { title: 'Client Login' }},
    
    // CMP Routes with Auth Guard - Temporarily Hidden
    // {path: 'admin-dashboard', component: AdminDashboardComponent, canActivate: [AuthGuardService], data: { title: 'Admin Dashboard' }},
    // {path: 'client-dashboard', component: ClientDashboardComponent, canActivate: [AuthGuardService], data: { title: 'Client Dashboard' }},
    // {path: 'vm-details/:id', component: VmDetailsComponent, canActivate: [AuthGuardService], data: { title: 'VM Details' }},
    // {path: 'client-registration', component: ClientRegistrationComponent, canActivate: [AuthGuardService], data: { title: 'Client Registration' }},

    {path: '**', component: ErrorComponent, data: { title: 'Page Not Found' }} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
